
$(document).ready( function(){

    $('.resource-filter-form input[type="checkbox"]').on('change', function(event){
        event.preventDefault();

        // $('.resources-page__loader').show();
        $('.resources').css('opacity', 0.5);

        var form = $(this).closest('form');
        var formData = form.serialize();
        var url = form.data("url");

        $.ajax({
            url: url,
            type: 'GET',
            data: formData,
            success: function(response) {
                $('.resources').html(response).css('opacity', 1);
                // $('.resources-page__loader').hide();
                
                var newUrl = $(".resources__all").data("url");
                history.pushState(null, null, newUrl);
            },
            error: function() {
                console.error('An error occurred while filtering resources.');
            }
        });
    });
    
    // Clear button functionality
    $('.resources-page__clear').on('click', function(event){
        event.preventDefault();

        var form = $('#Form_FilterForm');
        var url = form.data("url");

        $.ajax({
            url: url,
            type: 'GET',
            data: '', // blank to clear
            success: function(response) {
                $('.resources').html(response).css('opacity', 1);
                // $('.resources-page__loader').hide();
                
                var newUrl = $(".resources__all").data("url");
                history.pushState(null, null, newUrl);
            },
            error: function() {
                console.error('An error occurred while filtering resources.');
            }
        });
    });

});